module.exports = __webpack_public_path__ + "static/media/Lesson-4-2-Building-a-Relationship-with-the-Spirit.b80395fe.pdf";